import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useSearchParams } from "react-router-dom";
import { Range } from "react-range";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Products from "../components/products/Products";
import { HiStar } from "react-icons/hi2";
import { TbStarOff } from "react-icons/tb";
import { BsFillGridFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import ShopProducts from "../components/products/ShopProducts";
import Pagination from "../components/Pagination";
import {
  price_range_product,
  query_products,
} from "../store/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";

const Rating = ({ onChange }) => {
  const [rating, setRating] = useState(0);

  const handleRatingChange = (value) => {
    setRating(value);
    onChange(value);
  };

  return (
    <div className="py-3 flex flex-col gap-2">
      <h2 className="text-2xl font-bold mb-2 text-[#212730]">Rating</h2>
      <div className="flex items-center gap-2">
        {[1, 2, 3, 4, 5].map((value) => (
          <motion.span
            key={value}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.8 }}
            className={`text-3xl cursor-pointer ${
              rating >= value ? "text-orange-500" : "text-gray-400"
            }`}
            onClick={() => handleRatingChange(value)}
          >
            <HiStar />
          </motion.span>
        ))}
        <button
          onClick={() => handleRatingChange("")}
          className="group flex items-center justify-start w-11 h-11 bg-rose-600 rounded-full cursor-pointer relative overflow-hidden transition-all duration-300 shadow-lg md-lg:hover:w-11 hover:w-32 hover:rounded-full active:translate-x-1 active:translate-y-1"
        >
          <div className="flex items-center text-white justify-center w-full transition-all duration-300 group-hover:justify-start group-hover:px-4 ">
            <TbStarOff />
          </div>
          <div className="absolute pl-1 right-0 md-lg:hidden transform translate-x-full opacity-0 text-white text-lg font-semibold transition-all duration-300 group-hover:translate-x-[-16px] group-hover:opacity-100">
            Clear
          </div>
        </button>
      </div>
    </div>
  );
};

const SearchProducts = () => {
  let [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  const searchValue = searchParams.get("value");
  const { products, totalProduct, latest_product, priceRange, parPage } =
    useSelector((state) => state.home);

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [styles, setStyles] = useState("grid");
  const [filter, setFilter] = useState(true);
  const [state, setState] = useState({
    values: [priceRange.low, priceRange.high],
  });
  const [rating, setRatingQ] = useState("");
  const [sortPrice, setSortPrice] = useState("");

  useEffect(() => {
    dispatch(price_range_product());
  }, [dispatch]);
  useEffect(() => {
    setState({
      values: [priceRange.low, priceRange.high],
    });
  }, [priceRange]);

  useEffect(() => {
    const queryProductsParams = {
      low: state.values[0] || "",
      high: state.values[1] || "",
      category,
      rating,
      sortPrice,
      pageNumber,
      searchValue,
    };

    dispatch(query_products(queryProductsParams));
  }, [
    dispatch,
    state.values,
    category,
    rating,
    pageNumber,
    sortPrice,
    searchValue,
  ]);

  return (
    <div className="bg-[whitesmoke]">
      <Headers />
      <section
        className=" h-[220px] mt-6 md:hidden bg-cover bg-no-repeat relative bg-left"
        style={{ backgroundImage: `url(/images/banner/shop.jpg)` }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Ariz Supermart</h2>
              <div className="flex justify-center items-center gap-2 text-3xl w-full">
                <Link to="/">Home</Link>
                <span className="pt-1">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Products</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16">
        <div className="w-[85%]  md:w-[90%%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className={`md:block hidden ${!filter ? "mb-6" : "mb-0"}`}>
            <button
              onClick={() => setFilter(!filter)}
              className="text-center rounded-[10px] w-full py-2 px-3 bg-secondary text-white"
            >
              Filter Product
            </button>
          </div>
          <div className="w-full flex flex-wrap">
            <div
              className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${
                filter
                  ? "md:h-0 md:overflow-hidden md:mb-6"
                  : "md:h-auto md:overflow-auto md:mb-0"
              }`}
            >
              <h2 className="text-2xl font-bold mb-2 text-[#212730]">
                Category
              </h2>

              <div className="py-2 flex flex-col gap-5">
                <h2 className="text-2xl font-bold mb-2 text-[#212730]">
                  Price
                </h2>
                <Range
                  step={5}
                  min={priceRange.low}
                  max={priceRange.high}
                  values={state.values}
                  onChange={(values) => setState({ values })}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      className="w-[80%] ml-3 h-[3px] bg-secondary rounded-full cursor-default"
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      className="w-[15px] h-[15px] bg-secondary rounded-full "
                      {...props}
                    />
                  )}
                />
                <div>
                  <span className="text-slate-700  ml-3 font-bold text-lg">
                    ${Math.floor(state.values[0])} - $
                    {Math.floor(state.values[1])}
                  </span>
                </div>
              </div>
              <Rating onChange={setRatingQ} />
              <div className="py-5 px-1 flex flex-col gap-4 md:hidden">
                <Products title="Latest Products" products={latest_product} />
              </div>
            </div>
            <div className="w-9/12 md-lg:w-8/12 md:w-full">
              <div className="pl-8 md:pl-0">
                <div className="py-4 bg-white mb-10 px-3 rounded-[10px] flex justify-between items-center border">
                  <h2 className="text-lg  font-semibold md-lg:mx-0 text-[#212730] mx-5">
                    {totalProduct} Products
                  </h2>
                  <div className="flex justify-center items-center gap-5">
                    <div class="relative flex group rounded-[10px] bg-white overflow-hidden ">
                      <select
                        onChange={(e) => setSortPrice(e.target.value)}
                        class="appearance-none  relative text-indigo-900 bg-transparent ring-0 outline-none border border-neutral-200 text-sm font-semibold rounded-full focus:ring-violet-500 focus:border-indigo-900 block p-2.5"
                      >
                        <option value="">Sort By</option>
                        <option value="low-to-high">Low to High Price</option>
                        <option value="high-to-low">High to Low Price</option>
                      </select>
                      <svg
                        y="0"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        width="100"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="xMidYMid meet"
                        height="100"
                        class="w-8 h-8 relative right-0 -rotate-45 stroke-indigo-900 top-1.5 group-hover:rotate-0 duration-300"
                      >
                        <path
                          stroke-width="4"
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          fill="none"
                          d="M60.7,53.6,50,64.3m0,0L39.3,53.6M50,64.3V35.7m0,46.4A32.1,32.1,0,1,1,82.1,50,32.1,32.1,0,0,1,50,82.1Z"
                          class="svg-stroke-primary"
                        ></path>
                      </svg>
                    </div>

                    <div className="flex justify-center items-start gap-4 md-lg:hidden">
                      <div
                        onClick={() => setStyles("grid")}
                        className={`p-2 ${
                          styles === "grid" && "bg-slate-300"
                        } text-[#212730] hover:bg-slate-300 cursor-pointer rounded-lg`}
                      >
                        <BsFillGridFill />
                      </div>
                      <div
                        onClick={() => setStyles("list")}
                        className={`p-2 ${
                          styles === "list" && "bg-slate-300"
                        } text-[#212730] hover:bg-slate-300 cursor-pointer rounded-lg`}
                      >
                        <FaThList />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pb-8 md:pb-[20%]">
                  <ShopProducts products={products} styles={styles} />
                </div>
                <div>
                  {totalProduct > parPage && (
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      totalItem={totalProduct}
                      parPage={parPage}
                      showItem={Math.floor(totalProduct / parPage)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SearchProducts;
